import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Customer } from 'src/app/models';
import Swal from 'sweetalert2';
import { SalesStatesService } from '../split-bill/sales-states.service';
import { Subscription } from 'rxjs';
import { OrderData } from '../split-bill/sales-interfaces';
import { SelectorBoatDTO } from 'src/app/models/dtos/selector-boat-DTO';

@Component({
  selector: 'app-order-quota-select',
  templateUrl: './order-quota-select.component.html',
  styleUrls: ['./order-quota-select.component.scss']
})
export class OrderQuotaSelectComponent implements OnInit {
  @Output()
  onQuotaSelected:EventEmitter<any> = new EventEmitter<any>();
  
  canSave: boolean = false;
  invalidQuota: boolean;

  boat: SelectorBoatDTO;

  ownersSource: any[] = new Array();
  ownersTarget: any[] = new Array();
  
  customerSelected: Customer;
  
  orderData: OrderData;
  subscription: Subscription;

  constructor(
    private salesStatesService: SalesStatesService,
    public dialogRef: DynamicDialogRef,
  ) { }

  ngOnInit(): void {
    this.subscription = this.salesStatesService.orderData$.subscribe((_) => {
      this.orderData = this.salesStatesService.getOrderData();
    });
    this.boat = this.orderData.selectedBoat;
    this.customerSelected = this.orderData.selectedCustomer;
    this.getOwners();
  }

  getQuota(event, owner): void {
    const value = event.target.value;
    const index = this.ownersTarget.indexOf(owner);
    this.ownersTarget[index].singleOrderQuota = value ? +value : 0;
    this.calculateQuota();
  }

  calculateQuota(): void {
    let sum = 0;
    for (const quota of this.ownersTarget) {
      const quotaValue = quota.singleOrderQuota !== undefined && quota.singleOrderQuota !== null ? +quota.singleOrderQuota : 0;
      sum += quotaValue;
    }
    const isValid = Math.abs(sum - 100) < 0.01;
    this.invalidQuota = !isValid;
    this.canSave = isValid;
  }

  validateQuota(): void {
    for (const quota of this.ownersTarget) {
      if (quota.singleOrderQuota > 100) {
        Swal.fire('Rateio não pode ser maior que 100%', '', 'error');
        this.invalidQuota = true;
        break;
      }
      if (quota.singleOrderQuota < 0) {
        Swal.fire('Rateio não pode ser menor que 0', '', 'error');
        this.invalidQuota = true;
        break;
      }
    }
  }

  getOwners(): void {
    for (const customerB of this.boat.boatCustomers) {
      if (customerB.type === 'Owner' && customerB.customer.id !== this.customerSelected.id) {
        this.ownersSource.push(customerB);
      }
    }
    const customerBoat = this.boat.boatCustomers.find((os) => os.customer.id === this.customerSelected.id);
    this.ownersTarget.push(customerBoat);
    this.moveToSource();
    this.moveToTarget();
  }

  getOwnersQuota(): any[] {
    return this.ownersTarget;
  }

  moveToSource(): void {
    for (const owner of this.ownersSource) {
      owner.hasInput = false;
    }
    const ownersTarget = [...this.ownersTarget];
    if (ownersTarget.length > 0) {
      const quotaPerOwner = Number((100 / ownersTarget.length).toFixed(2));
      let totalAssigned = 0;
      
      for (let i = 0; i < ownersTarget.length - 1; i++) {
        ownersTarget[i].singleOrderQuota = quotaPerOwner;
        totalAssigned += quotaPerOwner;
      }
      
      if (ownersTarget.length > 0) {
        ownersTarget[ownersTarget.length - 1].singleOrderQuota = Number((100 - totalAssigned).toFixed(2));
      }
    }
    this.ownersTarget = [...ownersTarget];
    this.calculateQuota();
    this.save();
  }

  moveToTarget(): void {
    const ownersTarget = [...this.ownersTarget];
    if (ownersTarget.length > 0) {
      const quotaPerOwner = Number((100 / ownersTarget.length).toFixed(2));
      let totalAssigned = 0;
      
      for (let i = 0; i < ownersTarget.length - 1; i++) {
        ownersTarget[i].hasInput = true;
        ownersTarget[i].singleOrderQuota = quotaPerOwner;
        totalAssigned += quotaPerOwner;
      }
      
      if (ownersTarget.length > 0) {
        const lastIndex = ownersTarget.length - 1;
        ownersTarget[lastIndex].hasInput = true;
        ownersTarget[lastIndex].singleOrderQuota = Number((100 - totalAssigned).toFixed(2));
      }
    }
    this.ownersTarget = [...ownersTarget];
    this.calculateQuota();
    this.save();
  }

  save(): void {
    this.calculateQuota();
    this.validateQuota();

    if (!this.invalidQuota) {
      this.canSave = true;
      this.onQuotaSelected.emit(this.ownersTarget);
    } else {
      Swal.fire('Atenção', 'A soma das porcentagens deve ser igual a 100%', 'warning');
    }
  }
}
